module.exports = __webpack_public_path__ + "static/img/select_animated_new.2a5a9929.svg";